<template>
  <div id="app" class="other-nat">
    <div class="other-nat-page-background" />
    <van-form @submit="commit" class="other-nat-content">
      <h1 class="other-nat-content-title">
        核酸检测开单
      </h1>
      <div class="other-nat-content-input-view">
        <van-field :value="baseInfo.name" readonly label="姓名" />
        <van-field v-model="baseInfo.cardNo" readonly label="卡号" />
        <van-field v-model="baseInfo.idCard" readonly label="证件号" />
        <van-field v-model="baseInfo.phone" label="手机号" />
        <van-field v-model="baseInfo.sex" readonly label="性别" />
        <van-field v-model="getAge" readonly label="年龄" />
        <van-field v-model="baseInfo.address" label="地址" readonly />
        <van-field
          v-model="hospitals"
          :rules="[
            {
              required: true,
              message: '请选择采集点'
            }
          ]"
          @click="showPickerHospital = true"
          name="cjd"
          placeholder="请选择采集点"
          label="采集点"
          readonly
        />
        <van-field
          v-model="nonlocal"
          :rules="[
            {
              required: true,
              message: '请选择是否外来人员'
            }
          ]"
          @click="showPickerNonlocal = true"
          name="wlFlag"
          placeholder="请选择是否外来人员"
          label="是否外来人员"
          readonly
        />
        <div v-if="nonlocal == '是'">
          <van-field
            v-model="backDate"
            :rules="[
              {
                required: true,
                message: '请选择返回龙岩时间'
              }
            ]"
            @click="showPickerDate = true"
            name="backTime"
            placeholder="请选择返回龙岩时间"
            label="返回龙岩时间"
            readonly
          />
          <van-field
            v-model="backArea"
            :rules="[
              {
                required: true,
                message: '请选择返回龙岩地点'
              }
            ]"
            @click="showPickerArea = true"
            name="backAddress"
            placeholder="请选择返回龙岩地点"
            label="返回龙岩地点"
            readonly
          />
        </div>
        <van-field
          v-model="jobs"
          @click="showPickerJobs = true"
          readonly
          clickable
          label="职业"
          placeholder="选择职业"
        />
        <van-field
          v-model="subJobs"
          :disabled="!getSubJobs.length"
          :clickable="getSubJobs.length"
          :placeholder="getSubJobs.length ? '选择职业子类' : '无'"
          @click="getSubJobs.length ? (showPickerSubJobs = true) : ''"
          readonly
          label="职业子类"
        />
      </div>

      <div class="other-nat-content-tip">
        <p>注意事项</p>
        <div>
          1、该服务功能仅支持就诊卡开单，提交之前请确认信息是否正确<br />
          2、该服务功能仅支持线上核酸检测开单，采样工作请您到医院现场指定地点按照要求进行采集<br />
          3、申请提交成功后，会自动跳转进行结算<br />
          4、如需查询核酸检测报告结果，可通过该公众号“我的报告”入口进行查询<br />
          5、如需退费，请到医院现场窗口处理<br />
        </div>
      </div>
      <div class="other-nat-button">
        <p>轻按下方按钮，即表示您已阅读并了解以上注意事项</p>
        <ph-button
          :disabled="clickEnable === false"
          :style="clickEnable === false ? 'background-color:gray' : ''"
          native-type="submit"
          >登记信息</ph-button
        >
      </div>
    </van-form>
    <van-loading v-model="showloading" type="spinner" color="#1989fa" />
    <!-- 采集点列表 -->
    <van-popup v-model="showPickerHospital" position="bottom">
      <van-picker
        :columns="hospitalList"
        @confirm="hospitalsConfirm"
        @cancel="showPickerHospital = false"
        show-toolbar
      />
    </van-popup>
    <!-- 职业列表 -->
    <van-popup v-model="showPickerJobs" position="bottom">
      <van-picker
        :columns="getJobs"
        @confirm="jobsConfirm"
        @cancel="showPickerJobs = false"
        item-height="6rem"
        visible-item-count="3"
        show-toolbar
      />
    </van-popup>
    <!-- 子职业列表 -->
    <van-popup v-model="showPickerSubJobs" position="bottom">
      <van-picker
        :columns="getSubJobs"
        @confirm="subJobsConfirm"
        @cancel="showPickerSubJobs = false"
        item-height="6rem"
        visible-item-count="3"
        show-toolbar
      />
    </van-popup>
    <!-- 三码卡列表 -->
    <van-popup v-model="showPickerCards" position="bottom">
      <van-picker
        :columns="getCardList"
        @confirm="cardListConfirm"
        @cancel="showPickerCards = false"
        show-toolbar
      />
    </van-popup>
    <!-- 是否外来 -->
    <van-popup v-model="showPickerNonlocal" position="bottom">
      <van-picker
        :columns="nonlocalList"
        @confirm="nonLocalConfirm"
        @cancel="showPickerNonlocal = false"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="showPickerDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        @confirm="backDateConfirm"
        @cancel="showPickerDate = false"
        type="date"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="showPickerArea" position="bottom">
      <Area
        :area-list="areaList"
        :columns-placeholder="['请选择', '请选择', '请选择']"
        @cancel="showPickerArea = false"
        @confirm="backAreaConfirm"
        alt=""
      />
    </van-popup>
  </div>
</template>

<script>
import { Area, ContactList } from "vant";
import { Loading } from "element-ui";
import areaList from "./area";

export default {
  components: { Area },
  data() {
    return {
      openId: "",
      baseInfo: {},
      professions: [],
      address: "",
      jobs: "",
      jobsId: -1,
      subJobs: "",
      subJobsId: -1,
      cardList: [],
      currentCard: 0,
      hospitals: "",
      nonlocal: "",
      backDate: "",
      backArea: "",
      showPickerJobs: false,
      showPickerSubJobs: false,
      showPickerCards: false,
      showPickerHospital: false,
      showPickerNonlocal: false,
      showPickerDate: false,
      showPickerArea: false,
      tips: [
        "该服务功能仅支持本人多码融合码就诊卡开单，提交之前请确认信息是否正确",
        "该服务功能仅支持线上核酸检测开单，采样工作请您到医院现场指定地点按照要求进行采样",
        "申请提交成功后，会自动跳转进行结算",
        "如需查询核酸检测报告结果，可通过该公众号首页“检验报告”功能进行查询"
      ],
      loadingOptions: {
        lock: true,
        text: "加载中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      },
      loadingInstance: null,
      hospitalList: [
        "总院",
        "中医院",
        "翠江社区卫生服务中心",
        "湖村卫生院",
        "泉上中心卫生院",
        "中沙卫生院",
        "安远乡中心卫生院",
        "河龙卫生院",
        "水茜卫生院",
        "城南卫生院",
        "安乐卫生院",
        "曹坊中心卫生院",
        "治平畲族乡卫生院",
        "石壁镇中心卫生院",
        "济村卫生院",
        "方田卫生院",
        "淮土卫生院"
      ],
      nonlocalList: ["是", "否"],
      currentDate: new Date(),
      areaList: {},
      clickEnable: true,
      showloading: false
    };
  },
  computed: {
    getJobs() {
      return this.professions.map(item => {
        return item.itemName;
      });
    },
    getSubJobs() {
      if (this.jobsId > -1 && this.professions[this.jobsId].children) {
        return this.professions[this.jobsId].children.map(item => {
          return item.itemName;
        });
      }
      return [];
    },
    getCardList() {
      return this.cardList.map(item => {
        return item.cardNo;
      });
    },
    getAge() {
      if (!this.baseInfo.birthday) return 0;
      var r = this.baseInfo.birthday.match(/^(\d{1,4})(\d{1,2})(\d{1,2})$/);
      if (r == null) return 0;
      var d = new Date(r[1], r[2] - 1, r[3]);
      if (
        d.getFullYear() == r[1] &&
        d.getMonth() + 1 == r[2] &&
        d.getDate() == r[3]
      ) {
        var Y = new Date().getFullYear();
        return Y - r[1];
      }
      return 0;
    }
  },
  created() {
    const { query } = this.$route;
    this.openId = query.openId;
    // this.name = this.getQueryVariable("name");
    // this.idCard = this.getQueryVariable("idCard");
    this.name = query.name;
    this.idCard = query.idCard;
    this.areaList = areaList;
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .post(this.$api.TEST_GET_PATIENT, {
          name: this.name,
          idCard: this.idCard
        })
        .then(res => {
          this.baseInfo = res;
        });
      this.$http.post(this.$api.TEST_GET_PROFESSION, {}).then(res => {
        this.professions = res;
      });
      this.$http.post(this.$api.TEST_GET_CJD, {}).then(res => {
        this.hospitalList = res.map(item => {
          return item.hospitalName;
        });
      });
    },
    commit(value) {
      if (!this.$regular.phone(this.baseInfo.phone)) {
        alert("请输入您的电话号码");
        return;
      }
      if (!this.jobs) {
        alert("请选择职业");
        return;
      }
      if (this.getSubJobs.length && !this.subJobs) {
        alert("请选择职业子类");
        return;
      }

      const params = {
        openId: this.openId,
        ...this.baseInfo,
        ...value,
        zyfl: this.jobs,
        zyzfl: this.subJobs
      };
      this.clickEnable = false;
      // const paramsList = [];
      // for (var key in params) {
      //   paramsList.push(`${key}=${params[key]}`);
      // }
      // const path = `./pay.html?${paramsList.join("&")}`;
      // window.location.href = path;
      // const that = this;
      this.$http.post(this.$api.TEST_ADD_ORDER, params).then(res => {
        // const payParam = res.payparam;
        /* eslint-disable no-undef */
        // WeixinJSBridge.invoke(
        //   "getBrandWCPayRequest",
        //   JSON.parse(payParam),
        //   result => {
        //     if (result.err_msg == "get_brand_wcpay_request:ok") {
        //       that.$toast("正在开单");
        //       window.history.go(-1);
        //     }
        //   }
        // );
        let loadingInstance = null;
        loadingInstance = Loading.service(this.loadingOptions);
        window.location.href = res;
        //
      });
    },
    getSettlementUrl() {
      // axios.post("/palmhospitalWebService/rest/chargepayoff/sscardCheck.json",{
      //   cardType: this.baseInfo.cardType,
      //   cardNo: this.baseInfo.cardNo,
      //   name: this.baseInfo.name,
      //   idCard: this.baseInfo.idCard,
      // }).then(res =>  {
      //   console.log(res)
      // })
    },
    jobsConfirm(content, id) {
      this.jobs = content;
      this.jobsId = id;
      this.showPickerJobs = false;
    },
    subJobsConfirm(content, id) {
      this.subJobs = content;
      this.subJobsId = id;
      this.showPickerSubJobs = false;
    },
    cardListConfirm(_, id) {
      this.currentCard = id;
      this.showPickerCards = false;
    },
    hospitalsConfirm(content) {
      this.hospitals = content;
      this.showPickerHospital = false;
    },
    nonLocalConfirm(content) {
      this.nonlocal = content;
      this.showPickerNonlocal = false;
    },
    backDateConfirm(value) {
      this.backDate = this.$moment(value).format("YYYYMMDD");
      this.showPickerDate = false;
    },
    backAreaConfirm(value) {
      if (!value[0].name || !value[1].name || !value[2].name) return;
      this.backArea = `${value[0].name}${value[1].name}${value[2].name}`;
      this.showPickerArea = false;
    },
    getQueryVariable(variable) {
      if (!window.location.search) {
        return "";
      }
      var query = window.location.search.split("?")[1];
      if (!query) {
        return "";
      }
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURI(pair[1]);
        }
      }
      return "";
    }
  }
};
</script>

<style lang="less">
.other-nat {
  position: relative;
  background: #efeff4;

  // .van-cell {
  //   padding-top: 0.6rem;
  //   font-size: 0.94rem;
  // }
  .van-ellipsis {
    white-space: normal;
  }
  .van-field__label {
    width: 4rem;
    font-weight: 450;
  }

  &-page-background {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 9.63rem;
    background: linear-gradient(180deg, #108eee 0%, rgba(37, 193, 248, 0) 100%);
  }

  &-content {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow: scroll;
    &-title {
      margin-top: 1.19rem;
      color: white;
      font-weight: 600;
      font-size: 1.03rem;
      text-align: center;
    }
    &-input-view {
      margin: 1.19rem;
      padding: 0.5rem 0 1rem 0;
      background: white;
      border-radius: 0.5rem;

      &-tips {
        padding: 0.5rem 1rem;
        color: red;
      }
    }
    &-tip {
      margin: 0.75rem 1.19rem;
      padding-bottom: 1rem;
      background: white;
      border-radius: 0.5rem;

      p {
        padding-left: 0.5rem;
        color: #108eee;
        line-height: 2.31rem;
        background: rgba(16, 142, 238, 0.1);
        border-radius: 0.5rem 0.5rem 0 0;
      }
      > div {
        display: flex;
        padding: 0 0.5rem;
        font-size: 0.81rem;
        div {
          flex-shrink: 0;
          width: 0.3rem;
          height: 0.3rem;
          margin-top: 0.4rem;
          margin-right: 1rem;
          background: #108eee;
          border-radius: 0.3rem;
        }
      }
    }
  }

  &-button {
    bottom: 0;
    width: 100%;
    height: 6rem;
    padding-top: 0.5rem;
    text-align: center;
    background: white;
    p {
      margin: 0.5rem 1rem;
      font-size: 0.69rem;
      line-height: 0.8rem;
    }
  }
}
</style>
